import { useTranslation } from "react-i18next";
import { InputWithAlert } from "@/components/ui/input-with-alert";
import { DatePicker } from "@/components/ui/date-picker";

export const CorrectionDetailsSection = ({ form, inputChecked }) => {
  const { t } = useTranslation();

  const {
    correctionReason,
    setCorrectionReason,
    issueDate,
    setIssueDate,
  } = form;

  const reasonError = inputChecked && (!correctionReason || correctionReason.length < 10);
  const dateError = inputChecked && !issueDate;

  return (
    <div className="w-full pb-6">
      <div className="text-xl font-medium pb-6">
        {t("invoices:correction_title")}
      </div>

      <div className="w-full flex justify-between flex-wrap">
        <div className="w-full pb-4">
          <InputWithAlert
            label={`${t("invoices:correction_reason")} *`}
            value={correctionReason}
            onChange={(e) => setCorrectionReason(e.target.value)}
            placeholder={t("invoices:correction_reason_placeholder")}
            error={reasonError}
            errorMessage={t("invoices:correction_reason_min_length")}
            inputClassName={'h-12 mt-2 mb-4 bg-white'}
          />
        </div>

        <div className="w-full md:w-[49%] m-auto md:m-0">
          <DatePicker
            label={`${t("invoices:date_of_creation")} *`}
            date={issueDate}
            setDate={(date) => {
              if (!date) return;
              setIssueDate(date);
            }}
            inputClassName={`h-12 text-base ${dateError ? 'border-red-500' : ''}`}
          />
          {dateError && (
            <p className="text-red-500 text-sm mt-1">
              {t("empty_data_invalid")}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
